import type { FlowStep } from '@/data'
import api from '..'

// used to create a step from existing flow (put req doesn't create steps)
export async function createSteps(
  flowSlug: string,
  steps: FlowStep[],
): Promise<void> {
  await api.post(`/flow/${flowSlug}/steps`, { steps })
}
